// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 9ca3sE4gAMHXGHWcmrUodR
// Component: A1JWU10bpF
import * as React from "react";

import * as p from "@plasmicapp/react-web";
import * as ph from "@plasmicapp/host";

import {
  hasVariant,
  classNames,
  wrapWithClassName,
  createPlasmicElementProxy,
  makeFragment,
  MultiChoiceArg,
  SingleBooleanChoiceArg,
  SingleChoiceArg,
  pick,
  omit,
  useTrigger,
  StrictProps,
  deriveRenderOpts,
  ensureGlobalVariants
} from "@plasmicapp/react-web";

import "@plasmicapp/react-web/lib/plasmic.css";

import projectcss from "./plasmic_main.module.css"; // plasmic-import: 9ca3sE4gAMHXGHWcmrUodR/projectcss
import sty from "./PlasmicControlHelper.module.css"; // plasmic-import: A1JWU10bpF/css

import XSvgrepoComsvgIcon from "./icons/PlasmicIcon__XSvgrepoComsvg"; // plasmic-import: bhCqgTTbQ_/icon
import XSvgrepoCom1SvgIcon from "./icons/PlasmicIcon__XSvgrepoCom1Svg"; // plasmic-import: Rt_CBHYSZz/icon

export type PlasmicControlHelper__VariantMembers = {
  hidden: "hidden";
  english: "english";
};

export type PlasmicControlHelper__VariantsArgs = {
  hidden?: SingleBooleanChoiceArg<"hidden">;
  english?: SingleBooleanChoiceArg<"english">;
};

type VariantPropType = keyof PlasmicControlHelper__VariantsArgs;
export const PlasmicControlHelper__VariantProps = new Array<VariantPropType>(
  "hidden",
  "english"
);

export type PlasmicControlHelper__ArgsType = {};
type ArgPropType = keyof PlasmicControlHelper__ArgsType;
export const PlasmicControlHelper__ArgProps = new Array<ArgPropType>();

export type PlasmicControlHelper__OverridesType = {
  root?: p.Flex<"div">;
  closeHandle?: p.Flex<"div">;
};

export interface DefaultControlHelperProps {
  hidden?: SingleBooleanChoiceArg<"hidden">;
  english?: SingleBooleanChoiceArg<"english">;
  className?: string;
}

function PlasmicControlHelper__RenderFunc(props: {
  variants: PlasmicControlHelper__VariantsArgs;
  args: PlasmicControlHelper__ArgsType;
  overrides: PlasmicControlHelper__OverridesType;

  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const $ctx = ph.useDataEnv?.() || {};
  const args = React.useMemo(
    () =>
      Object.assign(
        {},

        props.args
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants
  };

  const currentUser = p.useCurrentUser?.() || {};

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        sty.root,
        { [sty.roothidden]: hasVariant(variants, "hidden", "hidden") }
      )}
    >
      {(hasVariant(variants, "hidden", "hidden") ? true : true) ? (
        <div
          className={classNames(projectcss.all, sty.freeBox__tzhkd, {
            [sty.freeBoxhidden__tzhkdgXm4I]: hasVariant(
              variants,
              "hidden",
              "hidden"
            )
          })}
        >
          <div className={classNames(projectcss.all, sty.freeBox__yrWd0)}>
            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__tfCQz,
                {
                  [sty.textenglish__tfCQziJxr6]: hasVariant(
                    variants,
                    "english",
                    "english"
                  )
                }
              )}
            >
              {hasVariant(variants, "english", "english")
                ? "Controls"
                : "Steuerung"}
            </div>
          </div>

          <p.Stack
            as={"div"}
            data-plasmic-name={"closeHandle"}
            data-plasmic-override={overrides.closeHandle}
            hasGap={true}
            className={classNames(projectcss.all, sty.closeHandle)}
          >
            <XSvgrepoComsvgIcon
              className={classNames(projectcss.all, sty.svg__e43Cm)}
              role={"img"}
            />
          </p.Stack>

          {true ? (
            <XSvgrepoCom1SvgIcon
              className={classNames(projectcss.all, sty.svg__dr6MG)}
              role={"img"}
            />
          ) : null}
        </div>
      ) : null}
      {(hasVariant(variants, "hidden", "hidden") ? true : true) ? (
        <div
          className={classNames(projectcss.all, sty.freeBox__iu0Uz, {
            [sty.freeBoxhidden__iu0UzgXm4I]: hasVariant(
              variants,
              "hidden",
              "hidden"
            )
          })}
        >
          <div className={classNames(projectcss.all, sty.freeBox__kdcz2)}>
            <div className={classNames(projectcss.all, sty.freeBox___0A1Of)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__gg4Aw,
                  {
                    [sty.textenglish__gg4AwiJxr6]: hasVariant(
                      variants,
                      "english",
                      "english"
                    )
                  }
                )}
              >
                {hasVariant(variants, "english", "english") ? "Mouse" : "Maus:"}
              </div>
            </div>

            <div className={classNames(projectcss.all, sty.freeBox__cbqzW)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__mi8ZS,
                  {
                    [sty.textenglish__mi8ZSiJxr6]: hasVariant(
                      variants,
                      "english",
                      "english"
                    )
                  }
                )}
              >
                {hasVariant(variants, "english", "english")
                  ? "Click & Drag"
                  : "Klicken & Ziehen"}
              </div>

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__bzbpd,
                  {
                    [sty.textenglish__bzbpdiJxr6]: hasVariant(
                      variants,
                      "english",
                      "english"
                    )
                  }
                )}
              >
                {hasVariant(variants, "english", "english")
                  ? "Look around"
                  : "Umschauen"}
              </div>
            </div>

            <div className={classNames(projectcss.all, sty.freeBox__xRgA)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__ufzIb,
                  {
                    [sty.textenglish__ufzIBiJxr6]: hasVariant(
                      variants,
                      "english",
                      "english"
                    )
                  }
                )}
              >
                {hasVariant(variants, "english", "english")
                  ? "Right-Click & Drag"
                  : "Rechts-Klick & Ziehen"}
              </div>

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__yoqzi,
                  {
                    [sty.textenglish__yoqziiJxr6]: hasVariant(
                      variants,
                      "english",
                      "english"
                    )
                  }
                )}
              >
                {hasVariant(variants, "english", "english")
                  ? "Move around"
                  : "Bewegen"}
              </div>
            </div>

            <div className={classNames(projectcss.all, sty.freeBox__xtZl1)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__gnbfW,
                  {
                    [sty.textenglish__gnbfWiJxr6]: hasVariant(
                      variants,
                      "english",
                      "english"
                    )
                  }
                )}
              >
                {hasVariant(variants, "english", "english")
                  ? "Doubleclick"
                  : "Doppelklick"}
              </div>

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__iUrst,
                  {
                    [sty.textenglish__iUrsTiJxr6]: hasVariant(
                      variants,
                      "english",
                      "english"
                    )
                  }
                )}
              >
                {hasVariant(variants, "english", "english")
                  ? "Make a note"
                  : "Notiz setzen"}
              </div>
            </div>

            <div className={classNames(projectcss.all, sty.freeBox__eq7Ft)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__gnTDs,
                  {
                    [sty.textenglish__gnTDsiJxr6]: hasVariant(
                      variants,
                      "english",
                      "english"
                    )
                  }
                )}
              >
                {hasVariant(variants, "english", "english") ? "Zoom" : "Zoomen"}
              </div>

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__rUoKa,
                  {
                    [sty.textenglish__rUoKaiJxr6]: hasVariant(
                      variants,
                      "english",
                      "english"
                    )
                  }
                )}
              >
                {hasVariant(variants, "english", "english")
                  ? "Fly to pointer location"
                  : "Fliegen zum Focus"}
              </div>
            </div>

            <div className={classNames(projectcss.all, sty.freeBox__rYuJj)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__nQqJi,
                  {
                    [sty.textenglish__nQqJiiJxr6]: hasVariant(
                      variants,
                      "english",
                      "english"
                    )
                  }
                )}
              >
                {hasVariant(variants, "english", "english")
                  ? "Scroll"
                  : "Scrollen"}
              </div>

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__rgHMh,
                  {
                    [sty.textenglish__rgHMhiJxr6]: hasVariant(
                      variants,
                      "english",
                      "english"
                    )
                  }
                )}
              >
                {hasVariant(variants, "english", "english")
                  ? "Move"
                  : "Bewegen"}
              </div>
            </div>

            <div className={classNames(projectcss.all, sty.freeBox___2HF4Z)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__afaPk,
                  {
                    [sty.textenglish__afaPkiJxr6]: hasVariant(
                      variants,
                      "english",
                      "english"
                    )
                  }
                )}
              >
                {hasVariant(variants, "english", "english")
                  ? "Keyboard:"
                  : "Tastatur:"}
              </div>
            </div>

            <div className={classNames(projectcss.all, sty.freeBox___7YafP)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__ia8Pn,
                  {
                    [sty.textenglish__ia8PniJxr6]: hasVariant(
                      variants,
                      "english",
                      "english"
                    )
                  }
                )}
              >
                {hasVariant(variants, "english", "english")
                  ? "Arrowkeys"
                  : "Pfeiltasten"}
              </div>

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__hXeed,
                  {
                    [sty.textenglish__hXeediJxr6]: hasVariant(
                      variants,
                      "english",
                      "english"
                    )
                  }
                )}
              >
                {hasVariant(variants, "english", "english")
                  ? "Move around"
                  : "Bewegen"}
              </div>
            </div>

            <div className={classNames(projectcss.all, sty.freeBox__fiJoR)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__hoaqc
                )}
              >
                {"W | A | S | D"}
              </div>

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___5VyLg,
                  {
                    [sty.textenglish___5VyLGiJxr6]: hasVariant(
                      variants,
                      "english",
                      "english"
                    )
                  }
                )}
              >
                {hasVariant(variants, "english", "english")
                  ? "Move around"
                  : "Bewegen"}
              </div>
            </div>

            <div
              className={classNames(projectcss.all, sty.freeBox__crmDv, {
                [sty.freeBoxenglish__crmDviJxr6]: hasVariant(
                  variants,
                  "english",
                  "english"
                )
              })}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___3Snnb
                )}
              >
                {"Q / E"}
              </div>

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__scoVk,
                  {
                    [sty.textenglish__scoVkiJxr6]: hasVariant(
                      variants,
                      "english",
                      "english"
                    )
                  }
                )}
              >
                {hasVariant(variants, "english", "english")
                  ? "Move up / Move down"
                  : "Hoch / Runter"}
              </div>
            </div>

            <div className={classNames(projectcss.all, sty.freeBox___30Pkd)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__hrkI
                )}
              >
                {"+ / -"}
              </div>

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___1PEmh,
                  {
                    [sty.textenglish___1PEmHiJxr6]: hasVariant(
                      variants,
                      "english",
                      "english"
                    )
                  }
                )}
              >
                {hasVariant(variants, "english", "english")
                  ? "Move up / Move down"
                  : "Hoch / Runter"}
              </div>
            </div>

            <div
              className={classNames(projectcss.all, sty.freeBox__otL4V, {
                [sty.freeBoxenglish__otL4ViJxr6]: hasVariant(
                  variants,
                  "english",
                  "english"
                )
              })}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__lzJg,
                  {
                    [sty.textenglish__lzJgiJxr6]: hasVariant(
                      variants,
                      "english",
                      "english"
                    )
                  }
                )}
              >
                {hasVariant(variants, "english", "english")
                  ? "Space"
                  : "Leertaste"}
              </div>

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__wesf4,
                  {
                    [sty.textenglish__wesf4IJxr6]: hasVariant(
                      variants,
                      "english",
                      "english"
                    )
                  }
                )}
              >
                {hasVariant(variants, "english", "english")
                  ? "Move up"
                  : "Hoch"}
              </div>
            </div>

            <div className={classNames(projectcss.all, sty.freeBox___791Wl)}>
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__dGMpJ
                )}
              >
                {"Shift"}
              </div>

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__cVjpZ,
                  {
                    [sty.textenglish__cVjpZiJxr6]: hasVariant(
                      variants,
                      "english",
                      "english"
                    )
                  }
                )}
              >
                {hasVariant(variants, "english", "english")
                  ? "Increase speed"
                  : "Geschwindigkeit erhöhen"}
              </div>
            </div>
          </div>
        </div>
      ) : null}
      {(hasVariant(variants, "hidden", "hidden") ? true : true) ? (
        <div
          className={classNames(projectcss.all, sty.freeBox__rx0XV, {
            [sty.freeBoxhidden__rx0XVgXm4I]: hasVariant(
              variants,
              "hidden",
              "hidden"
            )
          })}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text__pgmWk,
              {
                [sty.texthidden__pgmWKgXm4I]: hasVariant(
                  variants,
                  "hidden",
                  "hidden"
                )
              }
            )}
          >
            <React.Fragment>
              <span
                className={"plasmic_default__all plasmic_default__span"}
                style={{ fontWeight: 700 }}
              >
                {"Controls"}
              </span>
            </React.Fragment>
          </div>
        </div>
      ) : null}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root", "closeHandle"],
  closeHandle: ["closeHandle"]
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  typeof PlasmicDescendants[T][number];
type NodeDefaultElementType = {
  root: "div";
  closeHandle: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicControlHelper__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicControlHelper__VariantsArgs;
    args?: PlasmicControlHelper__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & Omit<PlasmicControlHelper__VariantsArgs, ReservedPropsType> & // Specify variants directly as props
    // Specify args directly as props
    Omit<PlasmicControlHelper__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: [...PlasmicDescendants[nodeName]],
          internalArgPropNames: PlasmicControlHelper__ArgProps,
          internalVariantPropNames: PlasmicControlHelper__VariantProps
        }),
      [props, nodeName]
    );

    return PlasmicControlHelper__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicControlHelper";
  } else {
    func.displayName = `PlasmicControlHelper.${nodeName}`;
  }
  return func;
}

export const PlasmicControlHelper = Object.assign(
  // Top-level PlasmicControlHelper renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    closeHandle: makeNodeComponent("closeHandle"),

    // Metadata about props expected for PlasmicControlHelper
    internalVariantProps: PlasmicControlHelper__VariantProps,
    internalArgProps: PlasmicControlHelper__ArgProps
  }
);

export default PlasmicControlHelper;
/* prettier-ignore-end */
